<template>
  <div class="assetsStatisticsDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="form.AssetId">
        {{ $t.enterpriseLogistics.editAssets }}
      </div>
      <div class="title" v-else>{{ $t.enterpriseLogistics.createAssets }}</div>

      <van-field
        v-model="form.AssetTypeName"
        :label="$t.enterpriseLogistics.assetType"
        @click="pickerShow('showAssetPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.ACName"
        :label="$t.enterpriseLogistics.class"
        @click="pickerShow('showACPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <div v-if="form.AssetType == 1">
        <van-field
          v-model="form.AssetFixedInfo.ProductName"
          :label="$t.enterpriseLogistics.goodsName"
          :placeholder="$t.meta.input"
          required
          :rules="formRule"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductModel"
          :label="$t.enterpriseLogistics.goodsModel"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductBrand"
          :label="$t.enterpriseLogistics.goodsBrand"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductConfig"
          :label="$t.enterpriseLogistics.goodsConfig"
          :placeholder="$t.meta.input"
        />

        <div class="custom-date">
          <div class="date-btn1">{{ $t.enterpriseLogistics.purchaseDate }}</div>
          <div class="date-btn2" @click="showTimeDate">
            <span v-if="form.AssetFixedInfo.PurchaseDate" class="value">{{
              form.AssetFixedInfo.PurchaseDate
            }}</span>
            <span v-else class="placeholder">{{ $t.meta.select }}</span>
          </div>
        </div>

        <van-field
          v-model="form.AssetFixedInfo.PurchaseAmount"
          :label="$t.enterpriseLogistics.purchaseAmount"
          :placeholder="$t.meta.input"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductSize"
          :label="$t.enterpriseLogistics.goodsSize"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductArea"
          :label="$t.enterpriseLogistics.goodsArea"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetFixedInfo.ProductAddress"
          :label="$t.enterpriseLogistics.goodsAddress"
          :placeholder="$t.meta.input"
        />
      </div>
      <div v-if="form.AssetType == 2">
        <van-field
          v-model="form.AssetDigitalInfo.AccountName"
          :label="$t.enterpriseLogistics.accountName"
          :placeholder="$t.meta.input"
          required
          :rules="formRule"
        />

        <van-field
          v-model="form.AssetDigitalInfo.AccountNumber"
          :label="$t.enterpriseLogistics.accountNumber"
          :placeholder="$t.meta.input"
          required
          :rules="formRule"
        />

        <van-field
          v-model="form.AssetDigitalInfo.LoginPassword"
          :label="$t.enterpriseLogistics.loginPassword"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetDigitalInfo.AccountLocation"
          :label="$t.enterpriseLogistics.accountLocation"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.AssetDigitalInfo.SetMealConfig"
          :label="$t.enterpriseLogistics.setMealConfig"
          :placeholder="$t.meta.input"
        />

        <div class="custom-date">
          <div class="date-btn1">{{ $t.enterpriseLogistics.openingDate }}</div>
          <div class="date-btn2" @click="showTimeDate">
            <span v-if="form.AssetDigitalInfo.AccountOpeningDate" class="value">{{
              form.AssetDigitalInfo.AccountOpeningDate
            }}</span>
            <span v-else class="placeholder">{{ $t.meta.select }}</span>
          </div>
        </div>

        <van-field
          v-model="form.AssetDigitalInfo.PurchaseAmount"
          :label="$t.enterpriseLogistics.purchaseAmount"
          :placeholder="$t.meta.input"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        />
      </div>

      <div class="multi-table" v-if="form.FileList && form.AssetType == 1">
        <van-field name="stepper" :label="$t.enterpriseLogistics.fileList">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.FileList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="$t.enterpriseLogistics.photo + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px" v-if="form.AssetType">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showAssetPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.assetType"
        show-toolbar
        :columns="assetTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="assetConfirm($event)"
        @cancel="showAssetPicker = false"
      />
    </van-popup>

    <van-popup v-model="showACPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.class"
        show-toolbar
        :columns="categoryList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event)"
        @cancel="showACPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="
          form.AssetType == 1
            ? $t.enterpriseLogistics.purchaseDate
            : $t.enterpriseLogistics.openingDate
        "
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "assetsStatisticsDetail",
  data() {
    return {
      form: {
        AssetId: null,
        //资产类型
        AssetTypeName: "",
        AssetType: 1,
        //类别
        ACName: "",
        ACId: null,
        AssetFixedInfo: {
          AFIId: "",
          ProductName: "",
          ProductModel: "",
          ProductBrand: "",
          ProductConfig: "",
          PurchaseDate: "",
          PurchaseAmount: "",
          ProductSize: "",
          ProductArea: "",
          ProductAddress: "",
        },
        FileList: [],
        AssetDigitalInfo: {
          ADIId: "",
          AccountName: "",
          AccountNumber: "",
          LoginPassword: "",
          AccountLocation: "",
          SetMealConfig: "",
          AccountOpeningDate: "",
          PurchaseAmount: "",
        },
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //选项
      assetTypeOptions: [],
      categoryList: [],
      //picker
      showAssetPicker: false,
      showACPicker: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //文件
      filesIndex: 0,
    };
  },
  created() {
    const { AssetId, AssetType } = this.$route.query;
    this.form.AssetId = AssetId;
    this.form.AssetType = AssetType;
    this.getAssetCategoryList(this.form.AssetType).then((success) => {
      if (success) {
        if (this.form.AssetType == 1) {
          this.form.AssetTypeName = this.$t.enterpriseLogistics.fixedAssets;
        }
        if (this.form.AssetType == 2) {
          this.form.AssetTypeName = this.$t.enterpriseLogistics.digitalAssets;
        }
        if (this.form.AssetId) {
          this.getAssetInfo();
        }
      }
    });
  },
  methods: {
    showTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (this.form.AssetType == 1) {
        this.form.AssetFixedInfo.PurchaseDate = formatDate(date);
      }
      if (this.form.AssetType == 2) {
        this.form.AssetDigitalInfo.AccountOpeningDate = formatDate(date);
      }
      this.showTimePicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getAssetInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          AssetId: this.form.AssetId,
          AssetType: this.form.AssetType,
        };
        this.$api.businessLogistics
          .getAssetInfo(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.ACId = data.ACId;
      var ac = this.categoryList.find((c) => c.value == data.ACId);
      if (ac) {
        this.form.ACName = ac.text;
      }

      if (data.AssetType == 1) {
        this.form.AssetFixedInfo.AFIId = data.AFIId;
        this.form.AssetFixedInfo.ProductName = data.ProductName;
        this.form.AssetFixedInfo.ProductModel = data.ProductModel;
        this.form.AssetFixedInfo.ProductBrand = data.ProductBrand;
        this.form.AssetFixedInfo.ProductConfig = data.ProductConfig;
        this.form.AssetFixedInfo.PurchaseDate = data.PurchaseDate;
        this.form.AssetFixedInfo.PurchaseAmount = data.PurchaseAmount;
        this.form.AssetFixedInfo.ProductSize = data.ProductSize;
        this.form.AssetFixedInfo.ProductArea = data.ProductArea;
        this.form.AssetFixedInfo.ProductAddress = data.ProductAddress;
        this.form.FileList = data.FileList;
      }
      if (data.AssetType == 2) {
        this.form.AssetDigitalInfo.ADIId = data.ADIId;
        this.form.AssetDigitalInfo.AccountName = data.AccountName;
        this.form.AssetDigitalInfo.AccountNumber = data.AccountNumber;
        this.form.AssetDigitalInfo.LoginPassword = data.LoginPassword;
        this.form.AssetDigitalInfo.AccountLocation = data.AccountLocation;
        this.form.AssetDigitalInfo.SetMealConfig = data.SetMealConfig;
        this.form.AssetDigitalInfo.AccountOpeningDate = data.AccountOpeningDate;
        this.form.AssetDigitalInfo.PurchaseAmount = data.PurchaseAmount;
      }
    },
    getAssetCategoryList(type) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.businessLogistics
          .getAssetCategoryList({
            AssetType: type,
          })
          .then((res) => {
            var categoryList = [];
            res.data.forEach((item) => {
              let data = {
                text: item.AssetName,
                value: item.ACId,
              };
              categoryList.push(data);
            });
            this.categoryList = this.$commonMethod.deepClone(categoryList);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName) {
      this.assetTypeOptions = [
        {
          text: this.$t.enterpriseLogistics.fixedAssets,
          value: 1,
        },
        {
          text: this.$t.enterpriseLogistics.digitalAssets,
          value: 2,
        },
      ];
      this[pickerName] = true;
    },
    pickerConfirm(e) {
      if (!e) {
        return;
      }
      this.form.ACName = e.text;
      this.form.ACId = e.value;
      this.showACPicker = false;
    },
    assetConfirm(e) {
      var initData = () => {
        this.form.ACName = "";
        this.form.ACId = "";
      };
      this.form.AssetTypeName = e.text;
      this.form.AssetType = e.value;
      if (this.form.AssetType == 1) {
        initData();
        this.getAssetCategoryList(1);
      }
      if (this.form.AssetType == 2) {
        initData();
        this.getAssetCategoryList(2);
      }
      this.showAssetPicker = false;
    },
    onSubmit() {
      var param = {};
      var request = null;
      param = this.form;
      if (this.form.AssetId) {
        param.AssetId = this.form.AssetId;
        request = this.$api.businessLogistics.editAssetInfo(param);
      } else {
        request = this.$api.businessLogistics.addAssetInfo(param);
      }
      this.$commonMethod.showLoading();
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleDelByIndex(index) {
      if (this.form.FileList.length > 0) {
        this.form.FileList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.FileList.length > 0) {
        this.form.FileList.pop();
      }
    },
    handleAdd() {
      this.form.FileList.push({
        FileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    onCopy(e, text) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.assetsStatisticsDetail {
  ::v-deep .number-label {
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .assetsStatisticsDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .assetsStatisticsDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .tool-button {
      align-items: center;
    }
  }
}
</style>
